var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreviewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.056,
    height: 58.467,
    viewBox: "0 0 67.056 58.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(464.064 250.837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(-464.064 -250.837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M-415.158-199.47c0,1.948-.531,2.469-2.507,2.469h-39.362c-1.928,0-2.46-.522-2.46-2.407,0-9.293,0-23.375,0-32.668,0-.33.029-.66.048-1.043h44.281v2.723h4.546c0-5.742,0-8.139,0-13.882a6.359,6.359,0,0,0-.167-1.622,6.324,6.324,0,0,0-6.355-4.924c-9.12-.019-8.675,0-17.8-.01-9.087,0-13.389-.01-22.48,0a6.288,6.288,0,0,0-6.613,6.45c-.043,13.566-.038,31.917,0,45.482a6.3,6.3,0,0,0,6.565,6.513c18.217.019,22.074.019,40.286,0a6.352,6.352,0,0,0,6.57-6.613v-2.235h-4.546Zm-44.286-45.2a1.511,1.511,0,0,1,1.325-1.483,7.452,7.452,0,0,1,1.426-.115c17.7,0,21.045,0,38.75,0,2.3,0,2.785.474,2.785,2.747v5.752h-44.305C-459.464-240.115-459.5-242.392-459.444-244.675Z",
    transform: "translate(464.064 250.837)",
    fill: "#3067ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M-445.154-234.694a2.036,2.036,0,0,1-.59,1.473,2.037,2.037,0,0,1-1.468.6,2.1,2.1,0,0,1-2.042-2.01,2.1,2.1,0,0,1,2.027-2.123,2.026,2.026,0,0,1,1.474.587A2.026,2.026,0,0,1-445.154-234.694Z",
    transform: "translate(456.34 243.491)",
    fill: "#3067ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M-418.413-236.748a2.042,2.042,0,0,1,1.448.648,2.042,2.042,0,0,1,.548,1.489,2.05,2.05,0,0,1-2.042,2,2.127,2.127,0,0,1-2.076-2.09A2.127,2.127,0,0,1-418.413-236.748Z",
    transform: "translate(441.364 243.49)",
    fill: "#3067ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M-434.818-234.727a2.031,2.031,0,0,1,.623-1.456,2.031,2.031,0,0,1,1.48-.565,2.12,2.12,0,0,1,2,2.054,2.115,2.115,0,0,1-2.084,2.079,2.042,2.042,0,0,1-1.455-.63A2.042,2.042,0,0,1-434.818-234.727Z",
    transform: "translate(448.813 243.49)",
    fill: "#3067ae",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(35.086 24.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M-374.4-181.262a16.4,16.4,0,0,1-8.765-2.571,28.68,28.68,0,0,1-7.384-6.463c-.176-.213-.3-.383-.068-.665a27.1,27.1,0,0,1,10.049-7.861,14.317,14.317,0,0,1,12.668.47,27.873,27.873,0,0,1,8.931,7.294c.214.258.287.445.034.745a26.7,26.7,0,0,1-10.476,7.991A13.422,13.422,0,0,1-374.4-181.262Zm-.324-16.7a7.315,7.315,0,0,0-7.334,7.262,7.346,7.346,0,0,0,7.273,7.336,7.347,7.347,0,0,0,7.334-7.273A7.318,7.318,0,0,0-374.72-197.959Z",
    transform: "translate(390.741 200.078)",
    fill: "#3067ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M-366.982-187.633c1.053.954,1.945,1.053,2.708.3.748-.738.656-1.627-.279-2.717a4.7,4.7,0,0,1,5.673,1.292,4.871,4.871,0,0,1-.318,6.5,4.843,4.843,0,0,1-6.5.3C-367.371-183.331-368-186.1-366.982-187.633Z",
    transform: "translate(378.607 195.095)",
    fill: "#3067ae",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 20.895,
    transform: "translate(-455.579 -225.235)",
    fill: "none",
    stroke: "#3067ae",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 20.895,
    transform: "translate(-455.579 -218.535)",
    fill: "none",
    stroke: "#3067ae",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 20.895,
    transform: "translate(-455.579 -211.836)",
    fill: "none",
    stroke: "#3067ae",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 20.895,
    transform: "translate(-455.579 -205.137)",
    fill: "none",
    stroke: "#3067ae",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewIcon);
export default __webpack_public_path__ + "static/media/preview-icon.dc3e0f9775a918bc3559fc2bcbf1538a.svg";
export { ForwardRef as ReactComponent };